<template>
  <v-form>
    <v-card>
      <v-container>
        <v-radio-group v-model="playerFormType" row>
          <v-radio label="Search for User" value="search"/>
          <v-radio label="Add Guest" value="guest"/>
        </v-radio-group>
        <SearchUser
            v-if="playerFormType === 'search'"
            @values="searchValues"
        />
        <NewGuestForm
            v-if="playerFormType === 'guest'"
            @value="guestValue"
            :table-id="$props.tableId"
        />
        <v-card-actions>
          <v-row>
            <v-spacer/>
            <v-btn @click="$emit('close', false)">Cancel</v-btn>
            <v-btn
                color="success"
                @click="addToPlayerList"
                :loading="loading"
                v-if="playerFormType === 'search'"
            >
              Add Players
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-container>
    </v-card>

  </v-form>
</template>

<script>
import SearchUser from "@/components/SearchUser";
import NewGuestForm from "@/components/forms/NewGuestForm";
export default {
  name: "AddPlayer",
  components: {NewGuestForm, SearchUser },
  props: {
    tableId: {
      type: String,
      required: true
    }
  },
  data: () => ({
    idValues: null,
    playerFormType: 'search',
    loading: false,
    guest: null
  }),
  methods: {
    async addToPlayerList() {
      try {
        this.loading = true
        await this.$store.dispatch("TABLE_ADD_PLAYERS", {
          players: this.idValues,
          _id: this.$props.tableId
        })
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    searchValues(values) {
      this.idValues = values
    },
    guestValue(value) {
      this.guest = value
    }
  },
  watch: {
    searchValues(val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>

</style>